export function numberOfDigits(num) {
    return Math.floor(num) !== num
        ? num.toString().split('.')[1].length || 0
        : 0;
}
export function formatDigits(num, prec) {
    if (prec === void 0) { prec = 2; }
    var digits = numberOfDigits(num);
    return digits <= prec ? num : num.toFixed(prec);
}



//////////////////
// WEBPACK FOOTER
// ./src/utils/numbers.ts
// module id = 306
// module chunks = 0